module.exports = __webpack_public_path__ + "assetst/img/tablet.6f76e5a2.svg";